<template>
 <div/>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "AuthComplete",
  mounted() {
    this.getToken()
  },
  methods: {
    ...mapActions('auth',['getToken'])
  }
}
</script>

<style scoped>

</style>
